// remove-button-renderer.component.ts
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-remove-button-renderer',
  template: ` <i class="fa fa-times-circle iconRed mt-2" (click)="onClick($event)"></i>`,
  styles:[
    `
    .iconRed {
  margin-top:8px; 
  text-align:center !important;
  color: red;
  font-size: 27px;
  margin-left:44%;
}

    `
  ]
})
export class RemoveButtonRendererComponent implements ICellRendererAngularComp {
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  // onClick($event: any) {
  //   if (this.params.onClick instanceof Function) {
  //     // Put anything into params you need to pass to the parent component
  //     const params = {
  //       event: $event,
  //       rowData: this.params.node.data // access to the row data here
  //     }
  //     this.params.onClick(params);

  //   }
  // }

  onClick(event: any): void {
    // call the removeRow method from the parent component (GridTypeComponent)
    this.params?.context?.componentParent?.removeRow({ rowData: this.params?.node?.data });
  }


  refresh(): boolean {
    return false;
  }
}
